export interface ISelectOptions {
  name: string;
  value: string;
}

export class SelectOptions implements ISelectOptions {
  name: string = '';
  value: string = '';

  constructor(configOverride?: Partial<ISelectOptions>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ISelectField {
  options: ISelectOptions[];
  optionName: string;
  optionValue: string;
}

export class SelectField implements ISelectField {
  options: ISelectOptions[] = [];
  optionName: string = 'name';
  optionValue: string = 'value';

  constructor(configOverride?: Partial<ISelectField>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
